/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/exclamation-mark-1214335': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 14a1.25 1.25 0 101.25 1.25A1.25 1.25 0 0012 14zm0-1.5a1 1 0 001-1v-3a1 1 0 00-2 0v3a1 1 0 001 1zM12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 18a8 8 0 118-8 8.01 8.01 0 01-8 8z"/>'
  }
})
